<template>
  <div>
    <el-form label-width="120px" size="mini">
      <el-form-item label="是否显示日期">
        <el-select v-model="attribute.isShowDate">
          <el-option
            v-for="(item, index) in list"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "cpt-time-show-option",
  props: {
    attribute: Object,
  },
  data() {
    return {
      list: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>